export type MinesAction = "START" | "REVEAL" | "COLLECT";

export interface Round {
  bet: string;
  multiplier: string;
  win: string;
  round_id: string;
  mines_count: number;
  created_at: string;
  last_state?: { data: MinesRoundData };
}

export interface MinesRoundData {
  mines_count: number;
  mine_positions?: number[];
  revealed_safe: number[];
  current_multiplier: string;
  /*True once any action in the round submitted auto_play=true. Sticky; omitted while false*/
  auto_play?: boolean;
  /*Cumulative, ordered union of every `cells` array submitted across all actions this
    round — including cells never reached because an earlier one in the same batch
    ended the round. Omitted while empty*/
  selected_cells?: number[];
}

export interface RoundFair {
  client_seed: string;
  combined_seed: string;
  combined_seed_hash: string;
  server_seed: string;
  server_seed_hash: string;
}

export interface RoundPlay {
  step: number;
  bet: string;
  free_bet_id?: string;
  action: MinesAction;
  client_seed: string;
  params?: RoundPlayParams;
}

export interface RoundPlayParams {
  mines_count?: number;
  cells?: number[];
  auto_play?: boolean;
}

export interface ActiveRound {
  id: string;
  free_bet_id?: string;
  finished: boolean;
  total_bet: string;
  total_win: string;
  capped: boolean;
  is_max_win: boolean;
  data: MinesRoundData;
  available_actions: MinesAction[];
}

export enum RoundCancelReason {
  I_FU = "INSUFFICIENT_FUNDS",
  I_FA = "INTEGRATION_FAILED",
  T_REF = "TRANSACTION_REFUNDED",
  T_REJ = "TRANSACTION_REJECTED",
  V_E = "VALIDATION_ERROR",
}
